import {clearStickyOtaMode} from 'hooks/useOtaMode/sessionStore'

import {reloadPage} from '@vio/core/src/_web/utils/browser/navigateTo'
import {setCookie} from '@vio/core/src/_web/utils/cookies'
import {
  OFFER_MODE_COOKIE,
  type OfferMode
} from '@vio/core/src/profile/constants'

/**
 * Stores the mode for the browser session and reloads without `profile`, so
 * neither the URL parameter nor the sticky flag can set another mode again.
 */
export const applyOfferMode = (mode: OfferMode) => {
  setCookie(OFFER_MODE_COOKIE, mode, {
    path: '/',
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production'
  })
  clearStickyOtaMode()

  const url = new URL(window.location.href)
  url.searchParams.delete('profile')
  window.history.replaceState(window.history.state, '', url)

  reloadPage()
}
